var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-layout-three-vertical"},[(_vm.checkSlot('top'))?_c('div',{staticClass:"nuttrema-layout-three-vertical__top"},[_vm._t("top")],2):_vm._e(),_vm._v(" "),(_vm.checkSlot('middle'))?_c('div',{staticClass:"nuttrema-layout-three-vertical__middle"},[_vm._t("middle")],2):_vm._e(),_vm._v(" "),(_vm.checkSlot('bottom'))?_c('div',{staticClass:"nuttrema-layout-three-vertical__bottom"},[_vm._t("bottom")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793304a6","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/layout/nuttrema-layout-three-vertical.vue
// module id = 3209
// module chunks = 0